import React from 'react';
import _ from 'lodash';
import {Pie, HorizontalBar} from 'react-chartjs-2';




export default ({item}) => {
  const options = { maintainAspectRatio: false,scales: {
    xAxes: [{
      barThickness: 10,
      categoryPercentage:5,
      barPercentage: 0.5,
      ticks: {
        suggestedMin: 0,//_.min( _.map(item , (d,k) => 1*d ) ) - 10,
        suggestedMax: _.max( _.map(item , (d,k) => 1*d ) ) + 10
      }
    }],
    yAxes: [{
      barThickness: 10,
      categoryPercentage:0.5,
      barPercentage: 0.5
    }]
  }};
  const data = {
    labels: _.keys(item),
    datasets: [{
      label: '',
      data: _.values(item),
      borderWidth: 1,

      backgroundColor: ["#0288d1",  "#90C2E7","#092327","#0B5351", "#4E8098"],
    }]
  };
console.log(data);
  return ( 
  <HorizontalBar width={250} height={250} options={options}  data={data} />
  );
}





// WEBPACK FOOTER //
// ./src/components/Charts/ChartBookingROI.jsx